import gql from "graphql-tag";

export const SAVE_SIMULATION = gql`
	mutation SaveSimulation($request: SimulationInput!) {
		SaveSimulation(request: $request) {
			simulationId
			isRemovedFromComparison
		}
	}
`;

export const UPDATE_SIMULATION_UNITS = gql`
	mutation UpdateSimulationUom($request: SimulationUnitsInput!) {
		UpdateSimulationUom(request: $request)
	}
`;

export const UPDATE_SIMULATION_BUSINESS_CASE = gql`
	mutation UpdateSimulationBusinessCase($request: SimulationBusinessCaseInput!) {
		UpdateSimulationBusinessCase(request: $request)
	}
`;

export const GET_SIMULATION = gql`
	query GetSimulationById($where: SimulationWhere!) {
		simulations(where: $where) {
			id
			lastUpdatedOn
			businessCase
			configuration
			createdOn
			lockedSections
			comments
			indications
			blueprint {
				status
			}
			domain {
				id
				name
			}
			simulationUserRole
			status
			isSimulationComplete
		}
	}
`;

export const GET_SIMULATION_USER_ROLES = gql`
	query GetSimulationRoles($id: ID!) {
		GetSimulationUserRoles(id: $id) {
			userId
			userRole
			userDomainId
			userDomainName
			role
			lastName
			firstName
			email
		}
	}
`;

export const GET_VALIDATED_COMPARISON_ARRAY = gql`
	query GetValidatedComparisonArray($simulationIds: [ID!]!) {
		GetValidatedComparison(simulationIds: $simulationIds) {
			validSimulationIds
		}
	}
`;

export const EDIT_SIMULATOR_ROLE = gql`
	mutation UpdateSimulatorRole($request: SimulationRoleInput!) {
		UpdateSimulatorRole(request: $request)
	}
`;

export const DELETE_SIMULATION = gql`
	mutation DeleteSimulation($id: ID!) {
		DeleteSimulation(id: $id)
	}
`;

export const GET_CURRENCIES = gql`
	query GetCurrencies {
		currencies {
			Code
			Name
			symbol
		}
	}
`;

export const GET_PROFILE_MEASURE_UNITS = gql`
	query GetProfileMeasureUnits($id: ID!, $email: String) {
		users(where: { id: $id, email: $email }) {
			id
			currency
			dosageMeasureUnit
		}
	}
`;

export const GET_PRODUCT_BLUEPRINTS_FOR_CURRENT_USER = gql`
	query GetProductBlueprintsForCurrentUser($domainId: ID!) {
		GetProductBlueprintsForCurrentUser(domainId: $domainId) {
			id
			productName
			formValues
		}
	}
`;

export const GET_USER_GLOBAL_DOMAIN_NAME = gql`
	query GetUserDomainName {
		GetUserDomainName
	}
`;
